import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './SuspenseLoader.module.scss';
const Loader = () => {
    return createPortal(_jsx("div", Object.assign({ className: styles.loader__container }, { children: _jsx("div", { className: styles.loader }) })), document.body);
};
export default Loader;
